import { JVCEF } from './emitters/JVCEF';
import { PATCEF } from './emitters/PATCEF';
import { VRGPA } from './emitters/VRGPA';
import { VRPAT } from './emitters/VRPAT';

export const emitters = {
  JVCEF,
  PATCEF,
  VRGPA,
  VRPAT,
};
